/**
 * Learner-side diagnostics client (Phase 1). Lists the diagnostics
 * assigned to me, fetches one to answer (grading material is stripped
 * server-side), and submits answers. Session-auth, like the rest of
 * platform-ui. Endpoints 404 when the platform diagnostics flag is off.
 */
import { api } from './client';

export interface MyDiagnosticRow {
  id: string;
  title: string;
  question_count: number;
  status: 'pending' | 'completed';
  assigned_at: string;
  submitted_at: string | null;
}

export interface AnswerableQuestion {
  id: string;
  prompt: string;
}

export interface AnswerableDiagnostic {
  id: string;
  title: string;
  questions: AnswerableQuestion[];
  submitted: boolean;
  submitted_at: string | null;
}

export const diagnosticsApi = {
  mine: () => api<{ diagnostics: MyDiagnosticRow[] }>('/api/platform/diagnostics'),
  get: (id: string) =>
    api<AnswerableDiagnostic>(`/api/platform/diagnostics/${encodeURIComponent(id)}`),
  submit: (id: string, answers: { question_id: string; text: string }[]) =>
    api<{ ok: boolean; submitted_at: string; answer_count: number }>(
      `/api/platform/diagnostics/${encodeURIComponent(id)}/submit`,
      { method: 'POST', body: { answers } }),
};
